import React from 'react';
import Link from 'next/link';

import { CheckMarkCircle2 } from '@lyearn/icons';
import { Box, Button, Typography } from '@lyearn/ui';

const Success = (props: { emailId: string }) => {
  const { emailId } = props;
  return (
    <Box className="flex h-full w-full items-center justify-center">
      <Box className="successContainer text-center">
        <Typography as="div" className="xs:heading-l mb-6 flex items-center justify-center">
          <CheckMarkCircle2 className="h-40 w-40 text-text-success me-12" />
          Password reset link sent!
        </Typography>
        <Typography as="div" className="mb-6 text-text-placeholder" variant="body-long-02">
          Reset password link has been successfully sent to your email{' '}
          <Typography className="mb-6 text-bg-accent" variant="body-long-02">
            {emailId}
          </Typography>{' '}
          Please click on the link to set new password
        </Typography>
        <Link href="/">
          <Button
            className="mt-30 normal-case"
            variant="filled"
            onClick={() => {
              window.location.href = '/';
            }}>
            Back to Home
          </Button>
        </Link>
      </Box>
    </Box>
  );
};

export default Success;
